import { BaseDTO } from '../../../../uinspect/src/app/global/interfaces/index';
import {IValuationNode} from './valuation-node.interface';

export interface ValuationNodeDTO extends BaseDTO, IValuationNode {
  valuationPillarId?: string;
}
